import { Injectable } from "@angular/core";
import { Observable, catchError, map, switchMap, tap, throwError, timeout } from 'rxjs';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { environment as ENV } from '../../../environments/environment';
import { URL_MAP } from "../../shared/urlMap";

@Injectable({
  providedIn: 'root'
})
export class PortafolioService {
  HOST = ENV.HOST;
  API = URL_MAP.API;

  constructor(
    private httpClient: HttpClient,
  ) { }
  
  public getPortafolioData(user:string, claveRol: string): Observable<any> {
    const httpOptions = {
      headers: new HttpHeaders({
        'Accept': "*/*"
      }),
    };
    let params = {
      user: user,
      userType: claveRol
    }
    return this.httpClient.post(`${this.HOST}${this.API.LISTPORTAFOLIO}`,params, httpOptions);      
  }

  public saveFavorite(data: any): Observable<any> {
    const httpOptions = {
      headers: new HttpHeaders({
        'Accept': "*/*"
      }),          
    };

    let params = {
      user: data.user,
      estado: data.status,
      idResource: data.id
    }
    return this.httpClient.post(`${this.HOST}${this.API.SAVEFAVORITEPORTAFOLIO}`,params, httpOptions);
  }     

  public countDownload(id: number, user:string, action: number): Observable<any> {  
    const httpOptions = {
      headers: new HttpHeaders({
        'Accept': "*/*"
      }),          
    };

    let params = {
      contentId: id,
      user: user,
      action: action
    }
    return this.httpClient.post(`${this.HOST}${this.API.DOWNLOADCOUNT}`,params, httpOptions);     
  } 
}
